import { render, staticRenderFns } from "./APNeedInDatas.vue?vue&type=template&id=5742ff60&scoped=true&"
import script from "./APNeedInDatas.vue?vue&type=script&lang=js&"
export * from "./APNeedInDatas.vue?vue&type=script&lang=js&"
import style0 from "./APNeedInDatas.vue?vue&type=style&index=0&id=5742ff60&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742ff60",
  null
  
)

component.options.__file = "APNeedInDatas.vue"
export default component.exports